import React from 'react';

function Title(props) {
    const { title, editable, canEdit, save, delete: deleteFn, add: addFn } = props;
    return (
        <div style={{ margin: '10px 0', padding: '0 10px', lineHeight: '32px', background: '#f1f1f1' }}>
            <span style={{fontWeight: 'bold' }}>{title}</span>
            {
                editable &&
                <div style={{float: 'right'}}>
                    <a onClick={() => save(canEdit)}>{canEdit ? '保存' : '修改'}</a>
                    {
                        deleteFn &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={deleteFn}>删除</a>
                        </span>
                    }
                    {
                        addFn &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={addFn}>添加一行备注</a>
                        </span>
                    }
                </div>
            }
        </div>
    );
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Components/Title.js